var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMrSushiLanding)?_c('MrSushi'):_c('Menu',{attrs:{"tid":_vm.tid,"ts":_vm.ts}})}
var staticRenderFns = []

export { render, staticRenderFns }